import { __decorate, __extends } from "tslib";
import { PROPS_LIST as PROPS_LIST, proxyTo, serialisable } from '../utils/FilterUtils';
import { FilterBase } from './FilterBase';
import { DisplacementTask } from './tasks/DisplacementTask';
var DisplacementFilter = /** @class */ (function (_super) {
    __extends(DisplacementFilter, _super);
    function DisplacementFilter(props) {
        var _this = _super.call(this) || this;
        _this._displacement = new DisplacementTask();
        _this.addTask(_this._displacement);
        _this.applyProps(props);
        return _this;
    }
    DisplacementFilter.prototype.applyProps = function (model) {
        if (!model)
            return;
        // run all model field that changed
        for (var _i = 0, _a = this[PROPS_LIST]; _i < _a.length; _i++) {
            var key = _a[_i];
            if (key in model) {
                this[key] = model[key];
            }
        }
    };
    DisplacementFilter.prototype.meashurePad = function (input, target) {
        target = _super.prototype.meashurePad.call(this, input, target);
        // because by dock scaleX is half range how we can move left/right
        // minX is -(scaleX / 2), maxX is (scaleX / 2)
        var SCALE = 4;
        target.x = Math.max(0, target.x - this.scaleX / SCALE | 0);
        target.y = Math.max(0, target.y - this.scaleY / SCALE | 0);
        target.width += Math.ceil(this.scaleX / SCALE);
        target.height += Math.ceil(this.scaleY / SCALE);
        return target;
    };
    DisplacementFilter.filterName = 'displacement';
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "mapBitmap", void 0);
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "mapPoint", void 0);
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "componentX", void 0);
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "componentY", void 0);
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "scaleX", void 0);
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "scaleY", void 0);
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "mode", void 0);
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "color", void 0);
    __decorate([
        serialisable,
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "alpha", void 0);
    return DisplacementFilter;
}(FilterBase));
export { DisplacementFilter };
